module.exports = __webpack_public_path__ + "assets/21e37fd9cf76eb8589e9c9df1d8838c2.png";